<template>
    <div>
        <v-stepper value="2">
            <v-stepper-header>
                <v-stepper-step step="1" complete>Détails préliminaires</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="2">Ajouter le responsable et l'organisateur de
                    l'évènement</v-stepper-step>
                <v-divider></v-divider>
                <!-- 
        <v-stepper-step step="3">Ajouter les participants</v-stepper-step> -->

                <!-- <v-divider></v-divider>

        <v-stepper-step step="4">Notification de rappel</v-stepper-step> -->
            </v-stepper-header>
        </v-stepper>
        <br />

        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
            {{ snackbar_message }}
        </v-snackbar>

        <v-form @submit.prevent="editEvent2()">
            <v-card-title>
                <h6 class="primary--text">
                    Saisir le nom du responsable de l'évènement
                </h6>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-layout wrap v-if="authUser">
                        <v-flex xs12>
                            <v-text-field v-model="authUser.full_name" label="Nom du responsable" clearable solo
                                disabled></v-text-field>

                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-card-text>
                <v-container>
                    <v-layout wrap>
                        <v-flex xs6 sm4>
                            <v-subheader>Organisateur de l'évènement</v-subheader>
                        </v-flex>

                        <v-flex xs6 sm8>
                            <v-radio-group v-model="event.organisator_type_id" inline>

                                <v-radio v-for="org in organisator_types" :key="org.id" :label="org.name" :value="org.id"
                                    color="primary"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        
                        <v-flex xs6 sm4 v-if="select == 'sae'">
                            <v-subheader>Type SAE</v-subheader>
                        </v-flex>
                        <v-flex xs6 sm8 v-if="select == 'sae'">
                            <v-radio-group v-model="event.sae_type_id" inline>
                                <v-radio v-for="sae in sae_types" :key="sae.id" :label="sae.name" :value="sae.id"
                                    color="primary"></v-radio>
                            </v-radio-group>
                        </v-flex>

                        <v-flex xs6 sm4>
                            <v-subheader>Nom du staff ACMA3 impliqué</v-subheader>
                        </v-flex>
                        <v-flex xs6 sm8>
                            <v-text-field v-model="event.staff_name" :rules="nameRules"
                                label="Nom du staff ACMA3 impliqué" clearable solo></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <div class="text-center mt-5">
                <v-btn rounded color="info" @click="previousStep()" :disabled="loadingSave"
                    class="mx-3">Précédent</v-btn>
                <v-btn rounded color="primary" :loading="loadingSave" :disabled="loadingSave" type="submit">Mettre à
                    jour</v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
// import { mapGetters } from "vuex";
import Permissions from '~/mixins/Permissions'
export default {
    name: "edit-event-2",
    mixins: [Permissions],
    data() {
        return {
            autoUpdate: true,
            user_ids: [],
            isUpdating: false,
            snackbar: false,
            snackbar_message: "",
            snackbar_timeout: 5000,
            snackbar_color: "",
            editable_id: null,
            event: {},
            nameRules: [v => !!v || "Nom requis"],
            select: "",
            loadingSave: false,
            eventOrganisationType: null

        };
    },

    created() {
        this.$checkPermission('edit events')
        this.fetchUtils();
    },

    mounted() {
        this.checkRegistering();
    },

    computed: {
        profiles() {
            return this.$store.getters.getProfiles;
        },
        sae_types() {
            return this.$store.getters.sae_types;
        },
        authUser() {
            return this.$store.getters.authUser
        },
        organisator_types() { return this.$store.getters.organisator_types; },

    },

    watch: {
        isUpdating(val) {
            if (val) {
                setTimeout(() => (this.isUpdating = false), 3000);
            }
        },

        'event.organisator_type_id'(newVal) {
            this.getEventOrganizationName(newVal);
        },

    },

    methods: {

        getEventOrganizationName(organisator_type_id) {

            this.select = this.organisator_types.find(org => org.id == organisator_type_id)['slug'];
        },

        async fetchUtils() {
            this.$store.dispatch('fetchOrganisatorTypes')

            let objet = await this.$store.getters.getEditableEvent;
            this.eventOrganisationType = objet.organisator_type ? objet.organisator_type : null
            let pays_id = objet.country_id;
            this.editable_id = objet.id;
            await this.$store.dispatch("loadProfiles", pays_id);
            let editable_profiles = await this.$store.getters.getEditableEvent
                .users;
            await this.$store.dispatch("loadEditableProfiles", editable_profiles);
            await this.$store.dispatch('fetchSaeTypes')
            setTimeout(() => this.edition, 2000);
        },

        async checkRegistering() {
            const item = JSON.parse(
                JSON.stringify(this.$store.getters.getEditableEvent)
            );
            // 
            if (item != null) {
                this.event = item;

                if (this.event.organisator_type) {
                    this.select = this.event.organisator_type.slug;
                }

                for (const user of item.users) {
                    this.user_ids.push(user.id);
                }
            }
        },

        remove(item) {
            const index = this.user_ids.indexOf(item.user_id);
            if (index >= 0) this.user_ids.splice(index, 1);
        },

        async edition() {
            let edit_profiles = await this.$store.getters.getEditableProfiles;
            let elem = this.user_ids;

            edit_profiles.forEach(function (item) {
                elem.unshift(item.user_id);
            });
        },

        async editEvent2() {
            this.event.event_organiser = this.select;
            if (this.event.event_organiser !== "sae") {
                this.event.sae_type_id = '';
            }
            if (
                this.event.event_organiser == "sae" &&
                this.event.sae_type_id == ""
            ) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message =
                    "Veuillez selectionner le type de SAE";
                return;
            } else if (
                this.event.event_organiser == "staff-acma-3" &&
                (this.event.staff_name == "" ||
                    this.event.staff_name == null)
            ) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message =
                    "Veuillez entrer le nom du staff ACMA3 impliqué";
                return;
            } else {
                this.event.user_ids = this.user_ids;
                this.loadingSave = true;
                const orgType = this.organisator_types.find(org => org.slug == this.select);

                this.event.organisator_type_id = orgType.id
                this.$store.dispatch("updateEvent2", this.event);

                // Save event first
                await this.$store.dispatch("updateEvent").then(value => {
                    this.loadingSave = false;
                    if (value == true) {

                        const now = new Date();
                        const start = new Date(this.event.event_date);
                        const end = new Date(this.event.event_date_end);

                        if (now >= start && now <= end) {
                            this.$router.push({
                                name: "events.in_progress",
                                params: { event_updated: value }
                            });
                        }
                        else if (now < end) {
                            this.$router.push({
                                name: "events.coming",
                                params: { event_updated: value }
                            });
                        } else if (now > start) {
                            this.$router.push({
                                name: "events.past",
                                params: { event_updated: value }
                            });
                        } else {
                            this.$router.push({
                                name: "events.in_progress",
                                params: { event_updated: value }
                            });
                        }
                    } else {
                        console.log("Something went wrong!");
                    }
                });

            }
        },

        async getEvent() {

            const uri =
                '/api/events/' +
                evenement_id +
                '?filter[id]=' +
                evenement_id +
                '?&include=country,users,municipality,domain,actors,department,district,town,chains,eventType,saeType'
            await axios
                .get(uri)
                .then(response => {
                    commit('setEditableEvent', response.data)
                })
                .catch(err => {
                    console.log('Editable event error ', err)
                })
        },
        previousStep() {
            this.$router.push({
                name: "events.edit",
                params: { Pid: this.editable_id }
            });
        }
    }
};
</script>

<style scoped>
.theme--light.v-subheader {
    font-size: 1.3em;
    color: black;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/events/edit-2.vue